// libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import ColumnCard, { ColumnCardProps } from '/react4xp/components/ColumnCard'

interface TwoColumnCardsProps {
    card?: Array<ColumnCardProps>
}

export default function TwoColumnCards({ card }: TwoColumnCardsProps) {
    return (
        <Section
            textColor='text-dark'
            className='two-column-cards'
        >
            <div className='grid-container'>
                <div className='grid-row'>
                    {card && card.length >= 1 && (
                        card.map((item, i) => (
                            <div className='c-md-6' key={i}>
                                <ColumnCard
                                    backgroundColor={item.backgroundColor}
                                    tagline={item.tagline}
                                    title={item.title}
                                    text={item.text}
                                    ctas={item.ctas?.map(cta => ({
                                        text: cta?.text,
                                        href: cta?.href,
                                        external: cta?.external
                                    }))}
                                />
                            </div>

                        ))
                    )}
                </div>
            </div>
        </Section>
    )
}